// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

export const zError = z.object({
    timestamp: z.string().optional(),
    error: z.string().optional(),
    message: z.string().optional()
});

export const zPsAanvraagRequest = z.object({
    scenarioId: z.string(),
    beginDatumtijd: z.iso.datetime(),
    eindDatumtijd: z.iso.datetime(),
    dienstIds: z.array(z.string()),
    scenarioBeginDatumtijd: z.iso.datetime(),
    scenarioEindDatumtijd: z.iso.datetime()
});

export const zPsAanvraagState = z.enum([
    'KLAAR',
    'BEZIG',
    'AFGEBROKEN',
    'AANGEVRAAGD',
    'ONBEKEND_TICKET'
]);

/**
 * Volledige status van een Aanvraag inclusief lifecycle timestamps.
 */
export const zPsAanvraagStatus = z.object({
    ticket: z.uuid(),
    status: zPsAanvraagState,
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime()
});

export const zPersoneelsinstellingen = z.object({
    knooppuntNaam: z.string(),
    voortijd: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).optional(),
    natijd: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).optional(),
    buffertijd: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).optional(),
    pauzeduur: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).optional(),
    maxtijdZonderPauze: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).optional(),
    standaardLooptijd: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' }).nullish(),
    passagierenGenererenInd: z.boolean().optional(),
    startLocatieId: z.string().nullish(),
    eindLocatieId: z.string().nullish(),
    geldigVanaf: z.iso.datetime(),
    geldigTot: z.iso.datetime().nullish()
});

export const zKlus = z.object({
    scenarioId: z.string().min(1).max(255),
    id: z.number().nullish(),
    beginDatumtijd: z.iso.datetime(),
    eindDatumtijd: z.iso.datetime(),
    klusActieId: z.string().nullish(),
    relatieActieId: z.string().nullish(),
    toelichting: z.string().max(45).nullish(),
    klusSoort: z.string().min(1).max(15),
    knooppuntNaam: z.string().max(20).optional(),
    dienstregelpuntStart: z.string().min(1).max(20),
    spoorStart: z.string().min(1).max(20),
    dienstregelpuntEind: z.string().min(1).max(20),
    spoorEind: z.string().min(1).max(20),
    bewegingsCode: z.string().max(36).nullish(),
    dienst: z.string().max(21).regex(/^(?:$|[A-Za-z0-9]{1,6}\.[0-9]{3}\.[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01]))$/).nullish(),
    tijdvensterBeginDatumtijd: z.iso.datetime().nullish(),
    tijdvensterEindDatumtijd: z.iso.datetime().nullish(),
    lastModified: z.iso.datetime().nullish()
});

export const zPersoneelsdienst = z.object({
    dienstnummer: z.int(),
    starttijd: z.iso.datetime(),
    eindtijd: z.iso.datetime(),
    standplaatsDrglptNaam: z.string()
});

export const zKlusSoort = z.object({
    klusCode: z.string().optional(),
    klusType: z.enum([
        'ONGEBONDEN',
        'BEWEGINGSGEBONDEN',
        'ACTIVITEITGEBONDEN'
    ]).optional()
});

export const zSleutelSpoor = z.object({
    dienstregelpunt: z.string(),
    naam: z.string()
});

/**
 * Een groep sporen die als een spoor gebruikt kunnen worden.
 */
export const zSpoorgroep = z.object({
    naam: z.string().optional(),
    sporen: z.array(zSleutelSpoor).optional()
});

export const zSleutelMaterieeltype = z.object({
    naam: z.string().optional(),
    lengteInMm: z.int().optional()
});

export const zActiviteit = z.object({
    tijd: z.iso.datetime(),
    beredenSpoorkant: z.enum([
        'onbekend',
        'a',
        'b'
    ]).optional(),
    compositie: z.array(zSleutelMaterieeltype).optional(),
    hoofdspoor: zSleutelSpoor
});

export const zRangeerbeweging = z.object({
    scenarioId: z.string().optional(),
    rangeerbewegingsactieId: z.string(),
    bewegingCode: z.string().optional(),
    geldigheid: z.iso.date().nullish(),
    start: zActiviteit,
    eind: zActiviteit
});

export const zPersoneelsverblijf = z.object({
    dienstregelpunt: z.string(),
    naam: z.string()
});

export const zDienstregelpunt = z.object({
    naam: z.string().optional(),
    pplgPlus: z.string().optional()
});

export const zLocatie = z.object({
    naam: z.string(),
    pplgPlus: z.array(z.string()),
    dienstregelpunten: z.array(zDienstregelpunt),
    sporen: z.array(zSleutelSpoor),
    spoorgroepen: z.array(zSpoorgroep).optional(),
    personeelsverblijven: z.array(zPersoneelsverblijf)
});

export const zMuteerKlussenResult = z.object({
    gemuteerdeKlussen: z.array(zKlus).optional(),
    verwijderdeKlussen: z.array(z.number()).optional()
});

export const zGeefKlussenPath = z.object({
    scenarioId: z.string()
});

/**
 * Lijst van klussen voor standplaats en periode met uitgebreide informatie
 */
export const zGeefKlussenResponse = z.array(zKlus);

export const zVerwijderKlusPath = z.object({
    klusId: z.int()
});

/**
 * Klus succesvol bijgewerkt
 */
export const zVerwijderKlusResponse = zMuteerKlussenResult;

export const zGeefKlusPath = z.object({
    klusId: z.int()
});

/**
 * Klus gevonden
 */
export const zGeefKlusResponse = zKlus;

export const zMaakKlusBody = zKlus;

/**
 * Klus succesvol aangemaakt
 */
export const zMaakKlusResponse = zMuteerKlussenResult;

export const zWijzigKlusBody = zKlus;

/**
 * Klus succesvol bijgewerkt
 */
export const zWijzigKlusResponse = zMuteerKlussenResult;

export const zGeefPersoneelsdienstenPath = z.object({
    scenarioId: z.string()
});

/**
 * Lijst van personeelsdiensten gevonden
 */
export const zGeefPersoneelsdienstenResponse = z.array(zPersoneelsdienst);

export const zGeefPersoneelsinstellingenPath = z.object({
    vanafTijd: z.iso.datetime(),
    totEnMetTijd: z.iso.datetime()
});

export const zGeefPersoneelsinstellingenQuery = z.object({
    knooppuntNaam: z.string().optional()
});

/**
 * Lijst van personeelsinstellingen die geldig zijn voor een bepaalde datumtijd range
 */
export const zGeefPersoneelsinstellingenResponse = z.array(zPersoneelsinstellingen);

/**
 * Lijst van klussoorten
 */
export const zGeefKlusSoortenResponse = z.array(zKlusSoort);

export const zGetLocatiesPath = z.object({
    scenarioId: z.string()
});

/**
 * successful operation
 */
export const zGetLocatiesResponse = zLocatie;

export const zGeefRangeerbewegingenPath = z.object({
    scenarioId: z.string()
});

/**
 * Lijst met rangeerbewegingen
 */
export const zGeefRangeerbewegingenResponse = z.array(zRangeerbeweging);

export const zGenereerKlussenQuery = z.object({
    scenarioId: z.string(),
    beginDatumtijd: z.iso.datetime(),
    eindDatumtijd: z.iso.datetime()
});

/**
 * Lijst van gegenereerde Klussen
 */
export const zGenereerKlussenResponse = zMuteerKlussenResult;

export const zGeefPsAanvragenQuery = z.object({
    status: zPsAanvraagState.optional(),
    scenarioId: z.string().optional()
});

/**
 * Lijst van scheduler Aanvraags
 */
export const zGeefPsAanvragenResponse = z.array(zPsAanvraagStatus);

export const zStartPsAanvraagBody = zPsAanvraagRequest;

/**
 * Aanvraag geaccepteerd met initiële status
 */
export const zStartPsAanvraagResponse = zPsAanvraagStatus;

export const zGeefPsAanvraagStatusPath = z.object({
    ticket: z.uuid()
});

/**
 * Status van de Aanvraag
 */
export const zGeefPsAanvraagStatusResponse = zPsAanvraagStatus;

export const zGeefPsAanvraagResultaatPath = z.object({
    ticket: z.uuid()
});

export const zGeefPsAanvraagResultaatResponse = z.union([
    z.array(zKlus),
    zPsAanvraagStatus
]);
